<template>
  <div>
    <v-btn
      small
      :loading="inProcess"
      :disabled="notSelected || inProcess"
      color="success"
      @click="showAlertSettingsDialog"
    >
      Assign
    </v-btn>
    <DialogUnitLevelAlertSettings
      v-model="showDialog"
      @confirm="handleAlertSettingsConfirm"
      @cancel="handleAlertSettingsCancel"
    />
  </div>
</template>
<script>
import useAlerts from "@tod-ui/composables/useAlerts";
import { computed, defineComponent, ref } from "vue";
import useDevice from "../useDevice";
import useFacility from "../../authentication/useFacility";
import DialogUnitLevelAlertSettings from "./DialogUnitLevelAlertSettings.vue";

export default defineComponent({
  name: "ButtonAssignDevice",
  components: {
    DialogUnitLevelAlertSettings,
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { moveDevice, selectedUnit } = useDevice(props.device);
    const { currentFacility } = useFacility();
    const notSelected = computed(() => !selectedUnit.value);
    const inProcess = ref(false);
    const showDialog = ref(false);
    const { addAlert } = useAlerts();

    const shouldShowDialog = computed(() => {
      try {
        if (!currentFacility || !currentFacility.value) {
          return false;
        }
        const facility = currentFacility.value;
        if (!facility || !facility.profile) {
          return false;
        }
        const profile = facility.profile;
        return (
          profile?.muteAlertsDuring === "day" &&
          (profile?.muteAlertsOrganizationType ?? "facility") === "zone"
        );
      } catch (error) {
        console.warn("shouldShowDialog error:", error);
        return false;
      }
    });

    return {
      moveDevice,
      notSelected,
      inProcess,
      selectedUnit,
      addAlert,
      showDialog,
      shouldShowDialog,
    };
  },
  methods: {
    showAlertSettingsDialog() {
      if (!this.device?.id || !this.selectedUnit) return;

      if (this.shouldShowDialog) {
        this.showDialog = true;
      } else {
        this.handleDirectAssign();
      }
    },
    async handleDirectAssign() {
      this.inProcess = true;
      try {
        const successMessage = await this.moveDevice(
          this.$apollo,
          this.selectedUnit,
          null
        );
        if (successMessage) {
          this.addAlert({
            type: "success",
            message: successMessage,
            timeout: 10,
          });
        }
      } catch (errorMessage) {
        this.addAlert({
          type: "error",
          message: errorMessage,
          timeout: 15,
        });
      }
      this.inProcess = false;
    },
    async handleAlertSettingsConfirm({ muteAlertsDuringDay }) {
      this.showDialog = false;
      this.inProcess = true;
      try {
        const muteValue = this.shouldShowDialog ? muteAlertsDuringDay : null;
        const successMessage = await this.moveDevice(
          this.$apollo,
          this.selectedUnit,
          muteValue
        );
        if (successMessage) {
          this.addAlert({
            type: "success",
            message: successMessage,
            timeout: 10,
          });
        }
      } catch (errorMessage) {
        this.addAlert({
          type: "error",
          message: errorMessage,
          timeout: 15,
        });
      }
      this.inProcess = false;
    },
    handleAlertSettingsCancel() {
      this.showDialog = false;
    },
  },
});
</script>
